<section class="desk">
  <p-breadcrumb [home]="home" [model]="itemss" />
  
  <div class="actions">
    <div class="back">
      <span>Pagina Web</span>
      <img src="shell/header/undo.svg" alt="Pagina Web" (press)="goToRibera()">
    </div>
    
    <button class="message">
      <img src="shell/header/messages-3.svg" alt="Mensajes">
    </button>
  </div>
</section>

<section class="mobile">
  <img class="logo" src="shell/Ribera_logo.svg" alt="logo">
  
  <div class="actions">
    <button (click)="goToDashboard()" (keydown.enter)="goToDashboard()">
      <i class="pi pi-user"></i>
    </button>
    <button (click)="toggleMenuRewards()" (keydown.enter)="toggleMenuRewards()">
      @if (viewRewardWallet) {
        <img src="shell/profile/close.svg" alt="Puntos">
      }@else {
      <img src="shell/header/mobile/six-points.svg" alt="Puntos">
      }
    </button>
    <button (click)="toggleMenu()" >
      @if (menuVisible) {
        <img src="shell/profile/close.svg" alt="Puntos">
      }@else {
      <img src="shell/header/mobile/Burger_menu.svg" alt="Menu">
      }
    </button>
  </div>

  @if(menuVisible) {
    @if(isPromotorPerfil()) {
      <lib-menu-mobile-promoter (emitCloseMenu)="toggleMenu()"></lib-menu-mobile-promoter>
    }@else {
      <lib-menu-mobile-partner (emitCloseMenu)="toggleMenu()"></lib-menu-mobile-partner>
    }
  }

  @if(viewRewardWallet){
    <div class="mobile-menu-overlay">
      <div
        class="backdrop"
        role="button"
        tabindex="0"
        (click)="toggleMenuRewards()"
        (keydown.enter)="toggleMenuRewards()"
        aria-label="Cerrar menú"
      ></div>

      <div class="menu-content-box">
        <lib-my-rewards></lib-my-rewards>
        <lib-promoters-wallet-transfer></lib-promoters-wallet-transfer>
      </div>
    </div>
  }
  
</section>

